// extracted by mini-css-extract-plugin
export var active = "_ti-1";
export var circle = "_ti-0";
export var completed = "_ti-2";
export var connector = "_ti-4";
export var connectorCompleted = "_ti-7";
export var connectorSpacer = "_ti-5";
export var iconStrokeOverride = "_ti-8";
export var labelContainer = "_ti-6";
export var pending = "_ti-3";